import getDocument from './get-document';

/**
 * @memberof ux-tread-dotcom-utils
 * @param {boolean} predicate - denotes whether to toggle overflow style on document.body
 * @returns {undefined} has no return value but conditionally alters the document.body.style
 */
export default function toggleBodyOverflow(predicate) {
  var doc = getDocument();
  if (predicate) {
    doc.body.style.overflow = 'hidden';
  } else {
    doc.body.style.overflow = 'auto';
  }
}